// API https://forkify-api.herokuapp.com/v2

export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const API_KEY = process.env.API_KEY;
export const TIMEOUT_SEC = 5;
export const RESULTS_PER_PAGE = 10
export const BOOKMARKS_STORAGE_KEY = 'bookmarks';
export const MODAL_CLOSE_TIME = 2.5;
export const MOBILE_EDGE = 980;